import React from "react";
import PropTypes from "prop-types";
import { buildQAHook } from "shared/utils";
import { elementClicked } from "shared/components/Cohesion";
import styles from "./styles.css";

const handleTagularEvent = (event) => {
  const text = event.currentTarget.getAttribute("data-title");
  const url = event.currentTarget.getAttribute("data-url");

  elementClicked({
    webElement: {
      location: "Nav",
      elementType: "Link",
      position: "Main Sub Menu",
      text,
    },
    outboundUrl: url,
  });
};

const Submenu = (props) => {
  const { featured, items, ...rest } = props;

  return (
    <ul {...rest} className={styles.submenu}>
      {featured && (
        <li key={featured.url}>
          <a
            className={styles.submenuFeaturedLink}
            href={featured.url}
            data-qa="featured"
            data-title={featured.title}
            data-url={featured.url}
            onClick={handleTagularEvent}
          >
            <img src={featured.image} alt="" />

            <div>
              {featured.title}
              <br />
              <b>{featured.subtitle}</b>
            </div>
          </a>
        </li>
      )}

      {items.map((item) => (
        <li key={item.url}>
          <a
            className={styles.submenuTextLink}
            href={item.url}
            data-qa={buildQAHook(item.title, "nav", "link")}
            data-title={item.title}
            data-url={item.url}
            onClick={handleTagularEvent}
          >
            {item.title}
          </a>
        </li>
      ))}
    </ul>
  );
};

Submenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
  featured: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string,
  }),
};

Submenu.defaultProps = {
  featured: null,
};

export default Submenu;
